import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css'

import axios from 'axios';
import { Card, Button, Checkbox, Form, Input, Divider } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import LoadingOverlay from '../../components/loadingOverlay/loadingOverlay';
import { apiUrl } from '../../utility/Connections';

const Login = () => {

    const [showLoading, setShowLoading] = useState(false)
    const [loadingText, setLoadingText] = useState(null)
    const [loginErrorText, setLoginErrorText] = useState(null)

    const navigate = useNavigate();

    const goToHome = (redirect) => {
        navigate(`${redirect}`);
    };

    const onFinish = async (values) => {
        setLoginErrorText(null)
        setShowLoading(true);
        setLoadingText("Iniciando sesión...");
        const formData = new FormData();
        formData.append('username', values.username);
        formData.append('password', values.password);

        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }

        await axios
            .post(`${apiUrl}/auth/login/`, formData, headers)
            .then(function (response) {
                localStorage.setItem("access_token", response.data.access);
                localStorage.setItem("refresh_token", response.data.refresh);
                setShowLoading(false);
                setLoadingText(null);
                goToHome(response.data.redirect);
            })
            .catch(function (error) {
                setShowLoading(false);
                setLoadingText(null);
                console.error(error)
                setLoginErrorText("Error al iniciar sesión");
            });
    };
    const onFinishFailed = (errorInfo) => {
        console.error('Failed:', errorInfo);
    };

    return <>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <div className='login-container'>
            <Card>
                <Form
                    layout="vertical"
                    name="normal_login"
                    className="login-form"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        label="Nombre de usuario"
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor ingrese su nombre de usuario',
                            },
                        ]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Nombre de usuario" />
                    </Form.Item>
                    <Form.Item
                        label="Contraseña"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor ingrese su contraseña',
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            placeholder="Contraseña"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Form.Item name="remember" valuePropName="checked" noStyle>
                            <Checkbox>Recuérdame</Checkbox>
                        </Form.Item>

                        <a className="login-form-forgot" href="/">
                            Olvidé mi contraseña
                        </a>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            Iniciar sesión
                        </Button>
                    </Form.Item>
                </Form>
                {
                    loginErrorText && <span className='login-error-text'>{loginErrorText}</span>
                }
            </Card>
            <Divider type="vertical" dashed />
            <img src='/talentha-favicon.png' alt="Logo Talentha" />
        </div>
    </>
}

export default Login;





